import type { ActivityCoverage } from '@lemontaigu/staff';
import { CHAT_API_BASE } from '../config.js';
import { supabase } from '../supabase.js';

// « Diffuser les postes à pourvoir » client (S4): sends the day's gaps to
// POST /api/staff/board-broadcast (site CF project — CHAT_API_BASE already
// points there for the chat functions; CHAT_ALLOWED_ORIGIN covers this
// app's origin). The function composes the French system message
// server-side and fans out push — this client only ships structured gaps.

export async function broadcastGaps(dateIso: string, gaps: ActivityCoverage[]): Promise<void> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (!token) throw new Error('Session expirée — reconnectez-vous.');

  const res = await fetch(`${CHAT_API_BASE}/api/staff/board-broadcast`, {
    method: 'POST',
    headers: { 'content-type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({
      date: dateIso,
      gaps: gaps.map((g) => ({
        label: g.activity.label,
        windowStart: g.windowStart,
        windowEnd: g.windowEnd,
      })),
    }),
  });
  if (!res.ok) {
    const detail = (await res.json().catch(() => null)) as { error?: string } | null;
    throw new Error(detail?.error ?? `Diffusion refusée (${res.status}).`);
  }
}
